
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[summitKey]",
      function () {
        return require("private-next-pages/event/[summitKey].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[summitKey]"])
      });
    }
  